import React, { useMemo } from "react";
import {
  ObjectNeedConfirmCssClasses,
  ObjectNeedConfirmTitles,
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";



const setRow = (row) => {
  if (row.needConfirmRequest !== undefined) {
    return (
      < span
        className={`label label-lg label-light-${ObjectNeedConfirmCssClasses[(+!row.needConfirmRequest)]
          } label-inline`
        }
      >
        <FormattedMessage id={ObjectNeedConfirmTitles[(+!row.needConfirmRequest)]} />
      </span >
    )
  }
}


export const NeedConfirmColumnFormatter = (cellContent, row) => setRow(row);

export const indexN = (cellContent, row, index) => {
  return (<div>{index + 1}</div>)
}